// This is the entry point for the home component
import React, { FC, useState, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Components
import { Accordion } from 'Components/Accordion';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { IntendedLevelOfStudyContainer } from './IntendedLevelOfStudy';
import { EntryTermContainer } from './EntryTerm';
import { IntendedMajorContainer } from './IntendedMajor';
import { GPAContainer } from './GPA';
import { TestScoresContainer } from './TestScores';

interface Props {
  majors: any[];
}
const testScroresOverrideStyles = {
  marginLeft: '17px',
};

const gPaOverrideStyles = {
  marginLeft: '17px',
};

const intendedMajorOverrideStyles = {
  marginLeft: '21px',
};

const entryTermOverrideStyles = {
  marginLeft: '17px',
};
const ProspectProfile: FC<Props> = (props: Props) => {
  const { prospectProfile } = useSelector((selectors: any) => selectors.filter);
  const {
    intendedLevelOfStudyQuery,
    entryTermQuery,
    intendedMajorQuery,
    gpaQuery,
    testScoresQuery,
  } = useSelector((selectors: any) => selectors.filter.query);
  const dispatch = useDispatch();

  const { majors } = props;

  const [intendedLevelOfStudyAccordion, setIntendedLevelOfStudyAccordion] =
    useState(intendedLevelOfStudyQuery !== '');
  const [entryTermAccordion, setEntryTermAccordion] = useState(
    entryTermQuery !== ''
  );
  const [intendedMajorAccordion, setIntendedMajorAccordion] = useState(
    intendedMajorQuery !== ''
  );
  const [gpaAccordion, setGPAAccordion] = useState(gpaQuery !== '');
  const [testScoresAccordion, setTestScoresAccordion] = useState(
    testScoresQuery !== ''
  );

  const { entryTerm, gpa, intendedMajor, intendedLevelOfStudy, testScores } =
    prospectProfile;

  useEffect(() => {
    if (intendedLevelOfStudyQuery !== '')
      setIntendedLevelOfStudyAccordion(intendedLevelOfStudyQuery !== '');
  }, [intendedLevelOfStudyQuery]);

  useEffect(() => {
    if (entryTermQuery !== '') setEntryTermAccordion(entryTermQuery !== '');
  }, [entryTermQuery]);

  useEffect(() => {
    if (intendedMajorQuery !== '')
      setIntendedMajorAccordion(intendedMajorQuery !== '');
  }, [intendedMajorQuery]);

  useEffect(() => {
    if (gpaQuery !== '') setGPAAccordion(gpaQuery !== '');
  }, [gpaQuery]);

  useEffect(() => {
    if (testScoresQuery !== '') setTestScoresAccordion(testScoresQuery !== '');
  }, [testScoresQuery]);

  const setIntendedLevelOfStudyAccordionCallBack = () => {
    setIntendedLevelOfStudyAccordion(!intendedLevelOfStudyAccordion);
  };
  const setEntryTermAccordionCallBack = () => {
    setEntryTermAccordion(!entryTermAccordion);
  };
  const setIntendedMajorAccordionCallBack = () => {
    setIntendedMajorAccordion(!intendedMajorAccordion);
  };
  const setGpaAccordionCallBack = () => {
    setGPAAccordion(!gpaAccordion);
  };
  const setTestScoresAccordionCallBack = () => {
    setTestScoresAccordion(!testScoresAccordion);
  };
  return (
    <ul>
      <li>
        <Accordion
          title="Intended Level of Study"
          id="intendedLevelOfStudy"
          isOpen={intendedLevelOfStudyAccordion}
          accordionCallback={setIntendedLevelOfStudyAccordionCallBack}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="Section"
          isActive={intendedLevelOfStudyQuery !== ''}
          overrideStylesChildContainer={{
            marginLeft: '17px',
          }}
        >
          <IntendedLevelOfStudyContainer
            intendedLevelOfStudy={intendedLevelOfStudy}
            dispatch={dispatch}
          />
        </Accordion>
      </li>
      <li>
        <Accordion
          title="Entry Term"
          id="entryTerm"
          isOpen={entryTermAccordion}
          accordionCallback={setEntryTermAccordionCallBack}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="Section"
          isActive={entryTermQuery !== ''}
          overrideStylesChildContainer={entryTermOverrideStyles}
        >
          <EntryTermContainer entryTerm={entryTerm} dispatch={dispatch} />
        </Accordion>
      </li>
      <li>
        <Accordion
          title="Intended Major"
          id="intendedMajor"
          isOpen={intendedMajorAccordion}
          accordionCallback={setIntendedMajorAccordionCallBack}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="Section"
          isActive={intendedMajorQuery !== ''}
          overrideStylesChildContainer={intendedMajorOverrideStyles}
        >
          <IntendedMajorContainer
            intendedMajor={intendedMajor}
            majors={majors}
            dispatch={dispatch}
          />
        </Accordion>
      </li>
      <li>
        <Accordion
          title="GPA"
          id="gpa"
          isOpen={gpaAccordion}
          accordionCallback={setGpaAccordionCallBack}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="Section"
          isActive={gpaQuery !== ''}
          overrideStylesChildContainer={gPaOverrideStyles}
        >
          <GPAContainer gpa={gpa} dispatch={dispatch} />
        </Accordion>
      </li>
      <li>
        <Accordion
          title="Test Scores"
          id="testScores"
          isOpen={testScoresAccordion}
          accordionCallback={setTestScoresAccordionCallBack}
          useTopDivider={false}
          useBottomDivider={false}
          accordionType="Section"
          isActive={testScoresQuery !== ''}
          overrideStylesChildContainer={testScroresOverrideStyles}
        >
          <TestScoresContainer testScores={testScores} dispatch={dispatch} />
        </Accordion>
      </li>
    </ul>
  );
};

export default withErrorBoundary(ProspectProfile);
